import React from "react";

import * as SC from "./PrintFooter.styled";

const PrintFooter = () => {
  const creationDate = new Date().toLocaleString("de");

  return (
    <SC.PrintFooterWrapper>
      <div>
        <span>Erstellungsdatum des Berichts: {creationDate}</span>
      </div>
      <SC.LogoImage src="../../../../images/logo__transparent.png" alt="logo" />
    </SC.PrintFooterWrapper>
  );
};

export default PrintFooter;
